module.exports = __webpack_public_path__ + "3a54315b50e71437bb15b5f216b90de2.jpg";